import Button from "@mostrans/web-components/components/base/Button";
import FormGroup from "@mostrans/web-components/components/base/FormGroup";
import Input from "@mostrans/web-components/components/base/Input";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React, { useState } from "react";
import { CreateMasterLokasiInterview } from "../../../GQL/mutations";
import { useApolloClient } from "@apollo/client";
import { FullScreenLoading } from "@mostrans/web-components/components/base/Loading";
import { toast, ToastContainer } from "react-toastify";

function ModalCreateOfficeLoc(props) {
  const { fetchMasterLokasiInterview } = props;
  const [modalCreateOfficeLoc, setModalCreateOfficeLoc] = useState(false);
  const [valueInputOffice, setValueInputOffice] = useState({
    nama: "",
    alamat: "",
  });
  const [isFullScreenLoading, setIsFullScreenLoading] = useState(false);
  const [errInput, setErrInput] = useState(false);
  const client = useApolloClient();

  const handleOpenModalCreateOfficeLoc = () => {
    setModalCreateOfficeLoc(true);
    handleClearValueState();
  };

  const handleCloseModalCreateOfficeLoc = () => {
    setModalCreateOfficeLoc(false);
    handleClearValueState();
    setErrInput(false);
  };

  const handleClearValueState = () => {
    setValueInputOffice({ nama: "", alamat: "" });
  };

  const submitOffice = async () => {
    const paramInsertOffice = {
      nama: valueInputOffice.nama,
      alamat: valueInputOffice.alamat,
    };

    if (valueInputOffice.nama === "" || valueInputOffice.alamat === "") {
      return setErrInput(true);
    }

    try {
      setIsFullScreenLoading(true);
      const responSubmit = await CreateMasterLokasiInterview(
        client,
        paramInsertOffice
      );
      if (responSubmit.data.createMasterLokasiInterview.errMsg === "OK") {
        toast.success("New Location Submited", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setIsFullScreenLoading(false);
        handleCloseModalCreateOfficeLoc();
        fetchMasterLokasiInterview();
      } else {
        toast.error(responSubmit.data.createMasterLokasiInterview.errMsg, {
          position: toast.POSITION.TOP_RIGHT,
        });
        setIsFullScreenLoading(false);
        setErrInput(false);
      }
    } catch (error) {
      alert(error);
    }
  };

  return (
    <React.Fragment>
      <FullScreenLoading
        show={isFullScreenLoading}
        backdropProps={{ style: { zIndex: 10000 } }}
      />
      <ToastContainer />
      <Button variant="outlined" onClick={handleOpenModalCreateOfficeLoc}>
        Add Office Location
      </Button>
      <Dialog
        open={modalCreateOfficeLoc}
        onClose={handleCloseModalCreateOfficeLoc}
      >
        <DialogTitle>Add New Office Location</DialogTitle>
        <DialogContent>
          <div className="form-row mb-1">
            <div className="col-md-12">
              <FormGroup
                isRequired
                placement="vertical"
                errorMessage={
                  <p style={{ fontSize: 13 }}>Office Name is required</p>
                }
                isError={errInput && !valueInputOffice.nama}
                showChildErrorSign
              >
                <label htmlFor="" style={{ fontSize: 12 }}>
                  Office Name
                </label>
                <Input
                  type="text"
                  style={{ width: "500px" }}
                  onChange={(e) =>
                    setValueInputOffice({
                      ...valueInputOffice,
                      nama: e.target.value,
                    })
                  }
                />
              </FormGroup>
            </div>
          </div>
          <div className="form-row mb-1">
            <div className="col-md-12">
              <FormGroup
                isRequired
                placement="vertical"
                errorMessage={
                  <p style={{ fontSize: 13 }}>Office Address is required</p>
                }
                isError={errInput && !valueInputOffice.alamat}
                showChildErrorSign
              >
                <label htmlFor="" style={{ fontSize: 12 }}>
                  Office Address
                </label>
                <Input
                  type="text"
                  onChange={(e) =>
                    setValueInputOffice({
                      ...valueInputOffice,
                      alamat: e.target.value,
                    })
                  }
                  multiline
                />
              </FormGroup>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button color="error" onClick={handleCloseModalCreateOfficeLoc}>
            Cancel
          </Button>
          <Button onClick={submitOffice}>Submit</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export default ModalCreateOfficeLoc;
